import {Injectable} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';


@Injectable({
  providedIn: 'root'
})
export class CaseDataService extends ExcTranslation {

  Case = {
    Update: (data: any): Observable<any> => {
      if (!this.excSecurity.isFeatured('CASEEDIT')) {
        this.modal.showToast('Sie sind nicht berechtigt den Auftrag zu editieren.', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(this.excRest.computeUrl('CaseU', {auID: data.auID})
        , data, 'CaseEdit-' + data.auID)
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Auftrag wurde editiert', 'md-toast', 'fal fa-check');
          }
        }));

    },

    ManualStateChange: (data: any, enmIdent: number, comment: string): Observable<any> => {
      if (!this.excSecurity.isFeatured('CASESTATCHANGE')) {
        this.modal.showToast('Sie sind nicht berechtigt den Status manuell zu ändern', 'md-toast', 'fal fa-ban');
        return of({success: false});
      }
      return this.excRest.sput(
        this.excRest.computeUrl('CaseU_StateManual', {auID: data.auID})
        , {auUPT: data.auUPT, au_enmIdent_AuftragStatus: enmIdent, au_stateChangeComment: comment}
        , 'CaseStateManually-' + data.auID
      ).pipe(
        map(response => {
          if (response && response.success) {
            this.modal.showToast('Status wurde erfolgreich geändert', 'md-toast', 'fal fa-check');
          }
          else {
            this.modal.showToast(
              this.getRessource('Statusänderung fehlgeschlagen')
              , 'md-toast', 'fas fa-exclamation');
          }
        })
      );
    }
  };

  constructor(private excRest: ExcRestService, private modal: ExgModalService, private excSecurity: ExcSecurityService) {
    super();
  }

}
